import { Result } from '@standardnotes/domain-core';
import { KeySystemPasswordType } from '@standardnotes/models';
export class ValidateVaultPassword {
    constructor(encryption, keys) {
        this.encryption = encryption;
        this.keys = keys;
    }
    execute(vault, password) {
        if (vault.keyPasswordType !== KeySystemPasswordType.UserInputted) {
            throw new Error('Vault uses randomized password and cannot be validated with password');
        }
        const rootKey = this.keys.getPrimaryKeySystemRootKey(vault.systemIdentifier);
        if (!rootKey) {
            return Result.ok(false);
        }
        const derivedRootKey = this.encryption.deriveUserInputtedKeySystemRootKey({
            keyParams: vault.rootKeyParams,
            userInputtedPassword: password,
        });
        return Result.ok(rootKey.isEqual(derivedRootKey));
    }
}
